export default function getTunedGuideId(guideItem, audioClipId, topicGuideId) {
  return audioClipId || topicGuideId || guideItem?.actions?.play?.guideId;
}
